import { MenuKey } from './constants';
import IconSeller from '@/assets/imgs/icon_seller.svg';
import IconCreator from '@/assets/imgs/icon_creator.svg';

export const IconMap = {
  [MenuKey.Seller]: IconSeller,
  [MenuKey.Creator]: IconCreator,
};
